import React, { Component } from "react";
import { Link } from "react-router-dom";
import Sticky from "react-stickynode";

// Images
import salogo from "../../../images/salogo.png";

import i18n from "i18next";
import { withTranslation } from "react-i18next";
class Header1 extends Component {
	componentDidMount() {
		// Mobile Menu sidebar function
		var btn = document.querySelector(".menuicon");
		var nav = document.querySelector(".menu-links");

		function toggleFunc() {
			btn.classList.toggle("open");
			nav.classList.toggle("show");
		}

		btn.addEventListener("click", toggleFunc);

		// Mobile Submenu open close function
		var navMenu = [].slice.call(
			document.querySelectorAll(".menu-links > ul > li")
		);
		for (var y = 0; y < navMenu.length; y++) {
			navMenu[y].addEventListener("click", function () {
				menuClick(this);
			});
		}

		function menuClick(current) {
			const active = current.classList.contains("open");
			navMenu.forEach((el) => el.classList.remove("open"));

			if (active) {
				current.classList.remove("open");
			} else {
				current.classList.add("open");
			}
		}
	}

	componentWillUnmount() {
		// 组件卸载时清除事件
		i18n.off("languageChanged");
	}




	render() {
		const { t } = this.props;
		return (
			<>
				<header className="header rs-nav">
					<div className="top-bar">
						<div className="container">
							<div className="row d-flex justify-content-between">
								<div className="topbar-left">
									<ul>
										<li>
											<a rel="noopener" href="/contact">
												<i className="fa fa-question-circle"></i>
												{t("Header_AskQues")}
											</a>
										</li>
										<li>
											<a rel="noopener" href="mailto:contact@aaio.com.au" style={{ textDecoration: "underline" }}>
												<i className="fa fa-envelope-o"></i>
												contact@aaio.com.au
											</a>
										</li>
									</ul>
								</div>
							</div>
						</div>
					</div>
					<Sticky enabled={true} className="sticky-header navbar-expand-lg">
						<div className="menu-bar clearfix">
							{/* 外层全宽 */}
							<div className="container-fluid">
								{/* 内层定宽且居中 */}
								<div className="nav-inner d-flex align-items-center justify-content-between mx-auto">
									{/* SA Logo */}
									<div className="menu-salogo">
										<Link to="/">
											<img alt="" src={salogo} />
										</Link>
									</div>

									{/* <!-- Mobile Nav Button ==== --> */}
									<button
										className="navbar-toggler collapsed menuicon justify-content-end"
										type="button"
										data-toggle="collapse"
										data-target="#menuDropdown"
										aria-controls="menuDropdown"
										aria-expanded="false"
										aria-label="Toggle navigation"
									>
										<span></span>
										<span></span>
										<span></span>
									</button>
									{/* <!-- Navigation Menu ==== --> */}
									<div
										className="menu-links navbar-collapse collapse justify-content-start" id="menuDropdown"
									>
										<ul className="nav navbar-nav">
											<li>
												<Link to="/">{t("Header_Home")}</Link>
											</li>
											<li className="active">
												<Link to="#">{t("Header_About")} <i className="fa fa-chevron-down"></i></Link>
												<ul className="sub-menu">
													{/* <li>
													<Link to="/about">{t("Header_About_Our_Organization")}</Link>
												</li> */}
													<li>
														<Link to="/aoai-team">{t("Header_About_Our_Team")}</Link>
													</li>
												</ul>
											</li>
											<li className="active">
												<Link to="#">{t("Header_IOAI")} <i className="fa fa-chevron-down"></i></Link>
												<ul className="sub-menu">
													<li className="active open">
														<Link to="#">{t("IOAI_2024")} <i className="fa fa-chevron-right"></i></Link>
														<ul className="sub-menu">
															<li>
																<Link to="/ioai-introduction">
																	{t("Header_IOAI_Introduction")}
																</Link>
															</li>
															<li>
																<Link to="/ioai-resource">
																	{t("Header_IOAI_Resource")}
																</Link>
															</li>
															<li>
																<Link to="/ioai-application">
																	{t("Header_IOAI_Application")}
																</Link>
															</li>
															<li>
																<Link to="/ioai-journey">
																	{t("Header_IOAI_Journey")}
																</Link>
															</li>
														</ul>
													</li>
												</ul>
											</li>
											<li className="active open">
												<Link to="/robotics-for-good-introduction">{t("Header_Robotics_For_Good")} <i className="fa fa-chevron-down"></i></Link>
												<ul className="sub-menu">
													<li className="active open">
														<Link to="#">{t("Robotics_For_Good_2025")} <i className="fa fa-chevron-right"></i></Link>
														<ul className="sub-menu">
															<li>
																<Link to="/robotics-for-good-introduction">
																	{t("Header_Robotics_For_Good_Introduction")}
																</Link>
															</li>
															<li>
																<Link to="/robotics-for-good-application">
																	{t("Header_Robotics_For_Good_Application")}
																</Link>
															</li>
															<li>
																<Link to="/robotics-for-good-journey">
																	{t("Header_Robotics_For_Good_Journey")}
																</Link>
															</li>
															<li>
																<Link to="/robotics-for-good-partners">
																	{t("Header_Robotics_For_Good_Partners")}
																</Link>
															</li>
														</ul>
													</li>
												</ul>
											</li>
											<li className="active">
												<Link to="#">{t("Header_Achievements_Photos_And_Videos")} <i className="fa fa-chevron-down"></i></Link>
												<ul className="sub-menu">
													<li>
														<Link to="/photos">
															{t("Header_Achievements_Photos")}
														</Link>
													</li>
													<li>
														<Link to="/videos">
															{t("Header_Achievements_Videos")}
														</Link>
													</li>
												</ul>
											</li>
											<li>
												<Link to="/aoai-sponsor">
													{t("Header_IOAI_Sponsor")}
												</Link>
											</li>
											<li>
												<Link to="/contact">{t("Header_Contact")}</Link>
											</li>
										</ul>
									</div>
									{/* <!-- Navigation Menu END ==== --> */}
								</div>
							</div>
						</div>
					</Sticky>
					{/* <!-- Search Box ==== --> */}
					<div className="nav-search-bar">
						<form action="#">
							<input
								name="search"
								type="text"
								className="form-control"
								placeholder="Type to search"
							/>
							<span>
								<i className="ti-search"></i>
							</span>
						</form>
						<span id="search-remove">
							<i className="ti-close"></i>
						</span>
					</div>
				</header>
			</>
		);
	}
}

export default Header1 = withTranslation()(Header1);
